import(/* webpackMode: "eager", webpackExports: ["ResumeSamplesWrapper"] */ "/home/vesper/code/resume-plus/apps/next/components/resume-samples-wrapper.tsx");
